
export enum MMModalJustifyContent {
    flexStart,
    flexEnd,
    center
}

export enum MMModalAnimationType {
    fade,
    down,
    none
}

